export default __webpack_public_path__ + "static/media/A-box.45351699.svg";